const formatVehicleBenefits = (extItem) => {
  const { benefits } = (extItem == null ? void 0 : extItem.data) || {};
  if (!benefits) {
    return [];
  }
  return benefits.filter((benefit) => benefit.id && benefit.displayName);
};
export {
  formatVehicleBenefits
};
